import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Dialog } from "@mui/material";
import {
  MyTimesheetDivider,
  MyTimesheetShowRequestDialogData,
  MyTimesheetShowRequestDialogHeader,
  MyTimesheetShowRequestDialogMessages,
  MyTimesheetShowRequestDialogStateData,
  MyTimesheetShowRequestDialogTimeData,
} from "my-timesheet/components";
import { OcConfirmationDialog } from "oc/components";

type MyTimesheetShowRequestDialogProps = {
  request: any;
  resetShowRequest: () => void;
  removeMyRequest: (id: string) => void;
  isMobile: boolean;
};

export const MyTimesheetShowRequestDialog = ({
  request,
  resetShowRequest,
  removeMyRequest,
  isMobile,
}: MyTimesheetShowRequestDialogProps) => {
  const { t } = useTranslation();
  const open = request ? true : false;

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleRemoveRequest = () => {
    if (!request) return;
    removeMyRequest(request._id);
    resetShowRequest();
    setShowConfirmDialog(false);
  };

  if (!request) return null;

  return (
    <>
      <Dialog open={open} fullScreen={isMobile ? true : false}>
        <Box
          id="my-sheet-show-request-dialog"
          width={isMobile ? "auto" : "568px"}
          padding="0px 16px 16px 16px"
        >
          <MyTimesheetShowRequestDialogHeader
            label={t("MY_TIMESHEET_ACTIVITY_REQUEST")}
            close={resetShowRequest}
            isMobile={isMobile}
          />
          <MyTimesheetDivider />
          <Box display="flex" flexDirection="row">
            <MyTimesheetShowRequestDialogData request={request} />
            <MyTimesheetShowRequestDialogStateData request={request} />
          </Box>
          <Box height="16px" />
          <MyTimesheetShowRequestDialogTimeData
            request={request}
            isMobile={isMobile}
          />
          <Box height="16px" />
          <MyTimesheetShowRequestDialogMessages request={request} />
          <Box height="32px" />
          <MyTimesheetDivider width="1px" />
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            justifyContent={
              request?.state === "requested" ? "space-between" : "flex-end"
            }
          >
            {request?.state === "requested" && (
              <Button
                id="remove-request"
                variant="text"
                color="primary"
                onClick={() => setShowConfirmDialog(true)}
                disableElevation
              >
                {t("OC_REMOVE_REQUEST")}
              </Button>
            )}
            {isMobile && <Box height="16px" />}
            <Button color="secondary" variant="text" onClick={resetShowRequest}>
              {t("OC_CANCEL")}
            </Button>
          </Box>
        </Box>
      </Dialog>
      <OcConfirmationDialog
        showDialog={showConfirmDialog}
        onClose={handleRemoveRequest}
        onCancel={() => setShowConfirmDialog(false)}
        title={t("MY_TIMESHEET_REVOKE_REQUEST")}
        texts={[t("OC_REVOKE_REQUEST_CONFIRM")]}
        okButtonText={t("OC_REMOVE_REQUEST")}
        cancelButtonText={t("OC_CANCEL")}
      />
    </>
  );
};

export default MyTimesheetShowRequestDialog;
